module.exports = __webpack_public_path__ + "assets/img/book.6a742941.png";